var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { attrs: { id: "WorkflofList" } }, [
    _c(
      "div",
      { attrs: { id: "workflow-list" } },
      [
        _c(
          "div",
          {
            staticClass: "d-flex right-page",
            staticStyle: { "background-color": "#ffffff" },
          },
          [
            _c(
              "div",
              { staticClass: "ml-3 mt-3", staticStyle: { flex: "0 0 100%" } },
              [
                _c("div", { staticClass: "big-title" }, [
                  _vm._v(_vm._s(_vm.$t("task.allWorkflow"))),
                ]),
                _vm._v(" "),
                _c(
                  "div",
                  { staticClass: "channels" },
                  [
                    _c(
                      "div",
                      {
                        staticClass: "story channel-add",
                        on: { click: _vm.createWorkflow },
                      },
                      [
                        _c("a-icon", {
                          staticStyle: { "font-size": "30px" },
                          attrs: { type: "plus-circle", theme: "filled" },
                        }),
                        _vm._v(" "),
                        _c(
                          "span",
                          {
                            staticClass: "text-large font-weight-bolder mt-2",
                            staticStyle: {
                              "font-size": "20px",
                              "letter-spacing": "2px",
                            },
                          },
                          [
                            _vm._v(
                              "\n                        " +
                                _vm._s(_vm.$t("task.createworkflow")) +
                                "\n                    "
                            ),
                          ]
                        ),
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _vm._l(_vm.getWorkflows(), function (workflow, index) {
                      return _c(
                        "div",
                        {
                          key: index,
                          staticClass: "channel-item",
                          on: {
                            click: function ($event) {
                              return _vm.openWorkflow(workflow._id)
                            },
                          },
                        },
                        [
                          _c(
                            "div",
                            { staticClass: "icon-container" },
                            [_c("WorkflowIcon")],
                            1
                          ),
                          _vm._v(" "),
                          _c(
                            "div",
                            {
                              directives: [
                                {
                                  name: "tippy",
                                  rawName: "v-tippy",
                                  value: {
                                    content: workflow.title,
                                    placement: "top",
                                  },
                                  expression:
                                    "{ content: workflow.title, placement: 'top' }",
                                },
                              ],
                              staticClass: "name-container",
                            },
                            [
                              _c("span", { staticClass: "name" }, [
                                _vm._v(
                                  _vm._s(
                                    workflow.title.length > 25
                                      ? workflow.title.substring(0, 25) + "..."
                                      : workflow.title
                                  )
                                ),
                              ]),
                              _vm._v(" "),
                              _c("span", { staticClass: "phone" }),
                            ]
                          ),
                          _vm._v(" "),
                          _c(
                            "div",
                            { staticClass: "options" },
                            [
                              _c(
                                "a-dropdown",
                                {
                                  attrs: {
                                    trigger: ["click"],
                                    placement: "bottomRight",
                                  },
                                  scopedSlots: _vm._u(
                                    [
                                      {
                                        key: "overlay",
                                        fn: function () {
                                          return [
                                            _c(
                                              "a-menu",
                                              [
                                                _c("a-menu-item", [
                                                  _c(
                                                    "div",
                                                    {
                                                      staticClass:
                                                        "icon-container",
                                                      on: {
                                                        click: function (
                                                          $event
                                                        ) {
                                                          return _vm.editWorkFlow(
                                                            workflow._id
                                                          )
                                                        },
                                                      },
                                                    },
                                                    [
                                                      _c(
                                                        "md-icon",
                                                        {
                                                          staticStyle: {
                                                            "margin-right":
                                                              "10px",
                                                          },
                                                        },
                                                        [_vm._v("edit")]
                                                      ),
                                                      _vm._v(" "),
                                                      _c("span", [
                                                        _vm._v(
                                                          _vm._s(
                                                            _vm.$t(
                                                              "message.edit"
                                                            )
                                                          )
                                                        ),
                                                      ]),
                                                    ],
                                                    1
                                                  ),
                                                ]),
                                                _vm._v(" "),
                                                _c("a-menu-item", [
                                                  _c(
                                                    "div",
                                                    {
                                                      staticClass:
                                                        "icon-container",
                                                      on: {
                                                        click: function (
                                                          $event
                                                        ) {
                                                          return _vm.deleteWorkflowFunc(
                                                            workflow
                                                          )
                                                        },
                                                      },
                                                    },
                                                    [
                                                      _c(
                                                        "md-icon",
                                                        {
                                                          staticStyle: {
                                                            "margin-right":
                                                              "10px",
                                                          },
                                                        },
                                                        [_vm._v("delete")]
                                                      ),
                                                      _vm._v(" "),
                                                      _c("span", [
                                                        _vm._v(
                                                          _vm._s(
                                                            _vm.$t(
                                                              "chatbotv2.delete"
                                                            )
                                                          )
                                                        ),
                                                      ]),
                                                    ],
                                                    1
                                                  ),
                                                ]),
                                              ],
                                              1
                                            ),
                                          ]
                                        },
                                        proxy: true,
                                      },
                                    ],
                                    null,
                                    true
                                  ),
                                },
                                [
                                  _c(
                                    "div",
                                    {
                                      staticClass:
                                        "icon-container ant-dropdown-link",
                                      on: {
                                        click: function (e) {
                                          return e.stopPropagation()
                                        },
                                      },
                                    },
                                    [
                                      _c(
                                        "span",
                                        { staticClass: "material-icons" },
                                        [_vm._v("more_horiz")]
                                      ),
                                    ]
                                  ),
                                ]
                              ),
                            ],
                            1
                          ),
                        ]
                      )
                    }),
                  ],
                  2
                ),
              ]
            ),
          ]
        ),
        _vm._v(" "),
        _vm.deleteModal
          ? _c("DeleteModal", {
              attrs: {
                description: _vm.$t("task.deleteWorkflow"),
                btnCancelText: _vm.$t("message.cancel"),
                btnoktext: _vm.$t("message.delete"),
              },
              on: {
                cancel: function ($event) {
                  _vm.deleteModal = false
                },
                confirm: _vm.softDeleteWorkflow,
              },
            })
          : _vm._e(),
      ],
      1
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }